module.exports = __webpack_public_path__ + "img/guideline_benefits.25258699.jpeg";